/* EcoYoung, hero strony głównej: suwak pokrowca (v9, 16.10.2026) */
(function () {
var E = window.EYH; if (!E) return;
var BOT = E.BOT, REST = 50, ORDER = ['cozy', 'teddy', 'shaggy'];
var EASE = 'cubic-bezier(.45,0,.2,1)', DUR = '.74s';
var slugify = E.slugify, zl = E.zl, el = E.el, geo = E.geo, place = E.place;

function init(root) {
if (root.__eyh) return; root.__eyh = true;
var data; try { data = JSON.parse(root.querySelector('[data-eyh-json]').textContent); } catch (e) { return; }
var rm = false; try { rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

var bodies = [];
(data.bodies || []).forEach(function (b) {
if (!b || !b.ins || !b.fabs) return;
b.colors = {}; var any = false;
ORDER.forEach(function (f) {
var p = b.fabs[f]; if (!p) return;
var seen = {}, list = [];
(p.v || []).forEach(function (v) {
if (!v.f || v.f.indexOf('_packshot') < 0) return;
var slug = slugify(v.c), m = v.f.match(/_([a-z0-9-]+)_packshot/);
if (!m || m[1] !== slug || seen[slug]) return;
seen[slug] = 1;
list.push({ slug: slug, name: v.c, file: v.f, src: v.s, thumb: v.t, vid: v.id });
});
if (list.length) { b.colors[f] = list; any = true; }
});
if (any) bodies.push(b);
});
if (!bodies.length) return;

var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
var tabsEl = $('[data-tabs]'), chipsEl = $('[data-chips]'), colWrapD = chipsEl.querySelector('[data-colwrap]');
var frame = $('[data-frame]'), box = $('[data-box]'), insImg = $('[data-ins]'), covWrap = $('[data-coverwrap]'), covImg = $('[data-cov]');
var CY = 0, line = $('[data-line]'), hd = $('[data-hd]'), hdLabel = $('[data-hdlabel]'), zin = $('[data-zin]'), drag = $('[data-drag]'), cap = $('[data-cap]'), ann = $('[data-announce]');
var backdrop = $('[data-backdrop]'), pops = $$('[data-pop]'), colBtns = $$('[data-colbtn]');

function colorsOf(bi, f) { var b = bodies[bi]; return (b && b.colors[f]) || []; }
function fabsOf(bi) { return ORDER.filter(function (f) { return colorsOf(bi, f).length; }); }
function pickCol(bi, f, want) {
var l = colorsOf(bi, f); if (!l.length) return null;
var def = data.fabMeta[f] && slugify(data.fabMeta[f].def || '');
for (var i = 0; i < l.length; i++) if (l[i].slug === want) return want;
for (i = 0; i < l.length; i++) if (l[i].slug === def) return def;
return l[0].slug;
}
function colObj(bi, f, slug) { var l = colorsOf(bi, f); for (var i = 0; i < l.length; i++) if (l[i].slug === slug) return l[i]; return l[0]; }

var startFab = fabsOf(0)[0];
var s = { b: 0, fab: startFab, col: pickCol(0, startFab, null), showFab: startFab, showCol: null, zip: REST, auto: false, touched: false, story: false,
armed: true, swaps: 0, dir: 'rest', lastCol: {}, open: false };
s.showCol = s.col;
var timers = [];
function t(fn, ms) { timers.push(setTimeout(fn, ms)); }
function clear() { timers.forEach(clearTimeout); timers = []; }
function set(o) { for (var k in o) s[k] = o[k]; render(); }

function dressBack(delay) {
t(function () { set({ auto: true, zip: 0, dir: 'left' }); }, delay);
t(function () { set({ auto: false, armed: true }); }, delay + 760);
}
function applyZip(raw) {
clear();
var z = Math.max(0, Math.min(100, Math.round(raw))); if (z >= 97) z = 100;
var n = { zip: z, auto: false, touched: true, dir: z < s.zip ? 'left' : (z > s.zip ? 'right' : s.dir), showFab: s.fab, showCol: s.col };
var armed = s.armed; if (z <= 30) armed = true;
if (z === 100 && armed) {
var fl = fabsOf(s.b), f = fl[(fl.indexOf(s.fab) + 1) % fl.length], c = pickCol(s.b, f, s.lastCol[f]);
n.fab = f; n.col = c; n.showFab = f; n.showCol = c; n.swaps = s.swaps + 1; armed = false;
ann.textContent = 'Zmieniono tkaninę na ' + data.fabMeta[f].name + '. Przesuń w lewo, żeby założyć pokrowiec.';
}
n.armed = armed; set(n);
}
function chooseBody(bi) {
if (bi === s.b) return; clear();
var f = colorsOf(bi, s.fab).length ? s.fab : fabsOf(bi)[0], c = pickCol(bi, f, s.lastCol[f] || s.col);
ann.textContent = 'Model: ' + bodies[bi].name;
set({ b: bi, fab: f, col: c, showFab: f, showCol: c, zip: REST, auto: false, armed: true, dir: 'rest', open: false, _bodyAnim: true });
}
function chooseFab(f) {
if (f === s.fab) return; clear();
var c = pickCol(s.b, f, s.lastCol[f]), z = (s.auto && !s.touched) ? REST : s.zip;
if (rm) { set({ fab: f, col: c, showFab: f, showCol: c, touched: true, auto: false, zip: z >= 97 ? 0 : z, armed: true, _fade: true }); return; }
if (z >= 97) { set({ fab: f, col: c, showFab: f, showCol: c, touched: true, auto: false }); dressBack(260); return; }
if (!s.story && z <= 3) {
set({ fab: f, col: c, auto: true, zip: 100, dir: 'right', touched: true, story: true });
t(function () { set({ showFab: s.fab, showCol: s.col }); }, 760);
dressBack(880); return;
}
set({ fab: f, col: c, showFab: f, showCol: c, touched: true, auto: false, _fade: true });
}
function chooseCol(c) {
if (c === s.col) { set({ open: false }); return; } clear();
var lc = {}; for (var k in s.lastCol) lc[k] = s.lastCol[k]; lc[s.fab] = c;
var z = (s.auto && !s.touched) ? REST : s.zip;
if (!rm && z >= 97) { set({ col: c, lastCol: lc, showFab: s.fab, showCol: c, touched: true, auto: false, open: false }); dressBack(260); return; }
set({ col: c, lastCol: lc, showFab: s.fab, showCol: c, auto: false, zip: z >= 97 ? 0 : z, open: false, _fade: true });
}

var sig = '', imgSig = '', insSig = '', box_ = { bL: 0, bW: 1 }, tabs = [];
// Próbka tkaniny: kafel z Files, a gdy go brak (np. Shaggy czarny), środek miniatury packshotu.
function sw(im, f, c) { var u = (data.tiles[f] || {})[c.slug]; im.classList.toggle('pk', !u); u = u || c.thumb; if (im.getAttribute('src') !== u) im.src = u; }

// Miniatury modeli w przełączniku pokazują aktualną tkaninę i kolor; nowa miniatura podmienia się dopiero po wczytaniu, bez mignięcia.
function thumbOf(i) { var f = colorsOf(i, s.fab).length ? s.fab : fabsOf(i)[0]; return colObj(i, f, pickCol(i, f, f === s.fab ? s.col : s.lastCol[f])); }
function setThumb(t, c) {
var g = geo(c.file, t.key, t.insF);
t.inner.style.cssText = 'position:absolute;left:0;top:50%;width:100%;aspect-ratio:1/1;transform:translateY(-' + (((g.top + BOT) / 2) * 100) + '%)';
t.im.src = c.thumb; place(t.im, g); t.cur = c.thumb;
}
function updTabs() {
if (!tabs.length) bodies.forEach(function (bb, i) {
var btn = el('button', 'eyh-tab eyh-tap'), th = el('span', 'eyh-th'), inner = el('span'), im = el('img'), lb = el('span');
btn.type = 'button'; im.alt = ''; inner.appendChild(im); th.appendChild(inner); btn.appendChild(th);
lb.textContent = window.innerWidth >= 990 ? bb.label : bb.labelM; btn.appendChild(lb);
btn.addEventListener('click', function () { chooseBody(i); });
tabsEl.appendChild(btn);
var t = { btn: btn, inner: inner, im: im, key: bb.key, insF: bb.ins.f, cur: '', want: '' };
tabs.push(t); setThumb(t, thumbOf(i));
});
tabs.forEach(function (t, i) {
t.btn.setAttribute('aria-pressed', i === s.b ? 'true' : 'false');
var c = thumbOf(i); if (c.thumb === t.cur || c.thumb === t.want) return;
t.want = c.thumb; var pre = new Image();
pre.onload = pre.onerror = function () { if (t.want === c.thumb) { t.want = ''; setThumb(t, c); } };
pre.src = c.thumb;
});
}

function buildLists() {
var b = bodies[s.b];
updTabs();
Array.prototype.slice.call(chipsEl.querySelectorAll('.eyh-chip')).forEach(function (n) { n.remove(); });
fabsOf(s.b).forEach(function (f) {
var on = f === s.fab, c = on ? s.col : pickCol(s.b, f, s.lastCol[f]);
var btn = el('button', 'eyh-chip eyh-tap'); btn.type = 'button'; btn.setAttribute('aria-pressed', on ? 'true' : 'false');
var fr = el('span', 'fr'), im = el('img'); im.alt = ''; im.loading = 'lazy'; sw(im, f, colObj(s.b, f, c)); fr.appendChild(im);
var tx = el('span', 'tx'), nm = el('span', 'nm'), ds = el('span', 'ds');
nm.textContent = data.fabMeta[f].name; ds.textContent = data.fabMeta[f].desc; tx.appendChild(nm); tx.appendChild(ds);
btn.appendChild(fr); btn.appendChild(tx);
btn.addEventListener('click', function () { chooseFab(f); });
chipsEl.insertBefore(btn, colWrapD);
});
var p = b.fabs[s.fab], list = colorsOf(s.b, s.fab), extra = (p && p.n ? p.n : list.length) - list.length;
if (b.key === 'wor' && s.fab === 'shaggy') extra = 0;
pops.forEach(function (pop) {
pop.innerHTML = '';
var h = el('span', 'hd'); h.textContent = 'Kolor · ' + data.fabMeta[s.fab].name; pop.appendChild(h);
list.forEach(function (c) {
var o = el('button', 'eyh-opt eyh-tap'); o.type = 'button'; o.setAttribute('aria-pressed', c.slug === s.col ? 'true' : 'false');
var d = el('img', 'eyh-dot'); d.alt = ''; sw(d, s.fab, c);
var nm = el('span'); nm.style.flex = '1'; nm.textContent = c.name;
o.appendChild(d); o.appendChild(nm);
o.insertAdjacentHTML('beforeend', '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2b1a12" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>');
o.addEventListener('click', function () { chooseCol(c.slug); });
pop.appendChild(o);
});
if (extra > 0 && p) { var a = el('a'); a.href = p.url; a.textContent = '+' + extra + ' na karcie produktu'; pop.appendChild(a); }
});
}

function render() {
var b = bodies[s.b], cur = colObj(s.b, s.fab, s.col), shown = colObj(s.b, s.showFab, s.showCol);
var nsig = s.b + '|' + s.fab + '|' + s.col;
if (nsig !== sig) { sig = nsig; buildLists(); }

if (insSig !== String(s.b)) {
insSig = String(s.b); insImg.src = b.ins.s; insImg.alt = 'Biały wkład ' + (b.insName || '') + ' z granulatem, bez pokrowca';
if (s._bodyAnim && !rm) { box.classList.remove('rise'); void box.offsetWidth; box.classList.add('rise'); }
}
var isig = s.b + '|' + shown.file;
if (imgSig !== isig) {
imgSig = isig; covImg.src = shown.src; covImg.alt = b.name + ' ' + data.fabMeta[s.showFab].name + ', kolor ' + shown.name;
if (s._fade && !rm) { covImg.classList.remove('fade'); void covImg.offsetWidth; covImg.classList.add('fade'); }
}
s._fade = false; s._bodyAnim = false;

// Bryła na środku między wyborem modelu a wyborem tkaniny, na telefonie między wyborem modelu a tekstem pod bryłą (kadr 1:1 przesunięty o 15% w górę).
if (!CY && frame.clientWidth) { var fr = frame.getBoundingClientRect(); CY = ((tabsEl.getBoundingClientRect().bottom + (window.innerWidth < 750 ? cap : chipsEl).getBoundingClientRect().top) / 2 - fr.top) / fr.width; }
var gi = geo(b.ins.f, b.key, b.ins.f), dy = (CY || 0.5) - (gi.top + BOT) / 2, bL = 0.5 - gi.w / 2 - 0.004, bW = gi.w + 0.008, v = s.zip / 100;
place(insImg, gi, dy); place(covImg, geo(shown.file, b.key, b.ins.f), dy);
var X = bL + bW * v, lt = gi.top - 0.02 + dy, lb = BOT + 0.025 + dy, ky = (gi.top + BOT) / 2 + dy;
box_ = { bL: bL, bW: bW };
var clip = s.zip <= 0 ? 0 : (s.zip >= 97 ? 100 : X * 100);
var tr = s.auto ? ('left ' + DUR + ' ' + EASE) : 'none';
covWrap.style.transition = s.auto ? ('clip-path ' + DUR + ' ' + EASE) : 'none';
covWrap.style.clipPath = 'inset(0 0 0 ' + clip + '%)';
line.style.cssText = 'top:' + (lt * 100) + '%;height:' + ((lb - lt) * 100) + '%;left:calc(' + (X * 100) + '% - 1px);transition:' + tr;
hd.style.cssText = 'top:calc(' + (ky * 100) + '% - 22px);left:calc(' + (X * 100) + '% - 22px);transition:' + tr;
zin.style.cssText = drag.style.cssText = 'left:calc(' + (bL * 100) + '% - 22px);width:calc(' + (bW * 100) + '% + 44px);top:' + (lt * 100) + '%;height:' + ((lb - lt) * 100) + '%';
if (String(zin.value) !== String(s.zip)) zin.value = s.zip;
hdLabel.style.display = s.touched ? 'none' : '';
var open = s.zip >= 97, closed = s.zip <= 3;
zin.setAttribute('aria-valuetext', open ? 'Pokrowiec zdjęty, widać biały wkład z granulatem. Tkanina: ' + data.fabMeta[s.fab].name : (closed ? 'Pokrowiec ' + data.fabMeta[s.fab].name + ' założony' : 'Pokrowiec zdjęty w ' + s.zip + ' procentach'));

var F = data.fabMeta[s.fab].name, col = cur.name.toLowerCase(), c;
if (!s.touched) c = 'Przesuń do końca i zmień tkaninę';
else if (open) c = (s.swaps > 0 && !s.armed) ? 'Wkład zostaje. Przesuń w lewo: ' + F : 'Pod spodem: biały wkład z granulatem';
else if (!closed && s.dir === 'rest') c = 'Przesuń do końca i zmień tkaninę';
else if (!closed) c = s.dir === 'left' ? 'Zakładasz ' + F + (s.swaps > 0 ? ' na ten sam wkład' : ' na wkład') : 'Pod spodem: biały wkład z granulatem';
else if (s.swaps > 0 && s.swaps % 3 === 0) c = 'Trzy tkaniny, jeden wkład';
else if (s.swaps > 0) c = F + ', ' + col + '. Przesuń po kolejną';
else c = 'Przesuń do końca i zmień tkaninę';
if (cap.textContent !== c) cap.textContent = c;

var p = b.fabs[s.fab];
$$('[data-colname]').forEach(function (n) { n.textContent = cur.name; });
$$('[data-coldot]').forEach(function (n) { sw(n, s.fab, cur); });
$$('[data-pname]').forEach(function (n) { n.textContent = b.name + ' ' + data.fabMeta[s.fab].name; });
$$('[data-price]').forEach(function (n) { n.textContent = zl(p.min); });
var a = $('[data-plink]'); a.href = p.url + '?variant=' + cur.vid; a.setAttribute('aria-label', 'Zobacz ' + b.name + ' ' + data.fabMeta[s.fab].name + ', kolor ' + cur.name);
colBtns.forEach(function (bt) { bt.setAttribute('aria-expanded', s.open ? 'true' : 'false'); });
pops.forEach(function (pp) { var vis = s.open && pp.parentNode.offsetParent !== null; pp.hidden = !vis; });
backdrop.hidden = !s.open;
}

zin.addEventListener('input', function () { applyZip(Number(zin.value)); });
function zAt(x) { var r = frame.getBoundingClientRect(); return ((x - r.left) / r.width - box_.bL) / box_.bW * 100; }
E.drag(drag, function (x) { applyZip(zAt(x)); });
E.keys(zin, function () { return s.zip; }, applyZip);
// Środek liczony od nowa przy każdej zmianie rozmiaru sekcji (fonty, pasek przewijania, obrót telefonu).
var reCY = function () { CY = 0; render(); }; if (window.ResizeObserver) new ResizeObserver(reCY).observe(root); else window.addEventListener('resize', reCY, { passive: true });
colBtns.forEach(function (bt) { bt.addEventListener('click', function () { set({ open: !s.open }); }); });
backdrop.addEventListener('click', function () { set({ open: false }); });
pops.forEach(function (pp) { pp.addEventListener('keydown', function (e) { if (e.key === 'Escape') set({ open: false }); }); });

render();

var warmed = {};
function warm(u) { if (u && !warmed[u]) { warmed[u] = 1; (new Image()).src = u; } }
function warmBody(bi) { var b = bodies[bi]; warm(b.ins.s); fabsOf(bi).forEach(function (f) { warm(colObj(bi, f, pickCol(bi, f, s.lastCol[f])).src); }); }
function warmColors() { colorsOf(s.b, s.fab).forEach(function (c) { warm(c.src); }); }
var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 300); };
function later() { idle(function () { warmBody(0); bodies.forEach(function (b, bi) { if (bi) warm(b.ins.s); fabsOf(bi).forEach(function (f) { warm(colObj(bi, f, pickCol(bi, f, null)).thumb); }); }); }); }
if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
tabsEl.addEventListener('pointerover', function (e) { var t = e.target.closest('.eyh-tab'); if (t) warmBody(Array.prototype.indexOf.call(tabsEl.children, t)); }, { passive: true });
tabsEl.addEventListener('touchstart', function (e) { var t = e.target.closest('.eyh-tab'); if (t) warmBody(Array.prototype.indexOf.call(tabsEl.children, t)); }, { passive: true });
colBtns.forEach(function (bt) { bt.addEventListener('pointerover', warmColors, { passive: true }); bt.addEventListener('focus', warmColors); });
if (!rm) {
t(function () { if (!s.touched) set({ auto: true, zip: 60 }); }, 1000);
t(function () { if (!s.touched) set({ zip: REST }); }, 1800);
t(function () { if (!s.touched) set({ auto: false }); }, 2560);
}
}

function boot() { document.querySelectorAll('[data-eyh]').forEach(init); }
boot();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-eyh]'); if (r) init(r); });
})()